/**
 * Procedure Categories and Procedures for DM in Critical Care Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 4-5: "Psychomotor Domain - Psychomotor System Skills")
 */
export const CRITICAL_CARE_PROCEDURES = {
  "Critical Airway & Respiratory Procedures": [
    "Emergency & Difficult Airway Management (Endotracheal Intubation)",
    "Fibreoptic Laryngoscopy & Fibreoptic Bronchoscopy with Bronchoalveolar Lavage (BAL)",
    "Percutaneous Tracheostomy & Mini-Tracheostomy",
    "Thoracocentesis & Intercostal Chest Drain Insertion",
    "Mechanical Ventilation (Invasive & Non-Invasive) & Endotracheal Suctioning",
  ],
  "Cardiovascular, Vascular Access & Hemodynamic Procedures": [
    "Arterial Catheterization (Arterial Line Placement) & Peripheral Venous Catheterization",
    "Central Venous Catheterization (Ultrasound-Guided CVC Placement)",
    "Surgical Isolation of Vein/Artery (Cut-down)",
    "Defibrillation, Electrical Cardioversion & Cardiac Pacing (Transvenous / Transthoracic)",
    "Pericardiocentesis",
    "Measurement of Cardiac Output & Derived Hemodynamic Variables",
  ],
  "Neurological, Gastrointestinal & Renal Critical Care Procedures": [
    "Lumbar Puncture & Neuraxial / Epidural Analgesia",
    "Nasogastric (NG) Tube Placement & Sengstaken-Blakemore Tube Placement",
    "Abdominal Paracentesis & Measurement of Intra-Abdominal Pressure",
    "Bedside Upper GI Endoscopy",
    "Urinary Catheterization & Renal Replacement Therapy (CRRT / Hemodialysis Setup)",
  ],
};

export const CRITICAL_CARE_CATEGORIES = Object.keys(CRITICAL_CARE_PROCEDURES);

export const isDMInCriticalCareDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("critical care") ||
    d.includes("intensive care") ||
    d.includes("icu") ||
    d.includes("ccu")
  );
};
